import getSearchFilterType from './get-search-filter-type';
import buildSearchValuesCheckboxSelect from './build-search-values-checkbox-select';
import { RANGE, CHECKBOX, SELECT } from '../constants';
const getQueryFilters = (searchFilter, query, listName) => {
  if (!searchFilter.settings || !searchFilter.settings.filters) return {
    valuesAnd: [],
    valuesOr: []
  };
  const rangeFilters = getSearchFilterType(searchFilter, RANGE);
  const checkboxFilters = getSearchFilterType(searchFilter, CHECKBOX);
  const selectFilters = getSearchFilterType(searchFilter, SELECT);
  const {
    values: valuesAnd,
    valuesOr
  } = buildSearchValuesCheckboxSelect(query, rangeFilters, checkboxFilters, selectFilters, listName);
  return {
    valuesAnd,
    valuesOr
  };
};
export default getQueryFilters;
//# sourceMappingURL=get-query-filters.js.map